import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { BreadcrumbLink } from '../interfaces/resources/breadcrumb-link.interface'

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  breadcrumbLinks = new BehaviorSubject<BreadcrumbLink[]>([])
}
